<template>
  <label class="weui-cell weui-check__label" :for="id">
    <div class="weui-cell__hd">
      <input type="checkbox" class="weui-check" :id="id" :checked="checked" @change="updateChecked">
      <i class="weui-icon-checked" />
    </div>
    <div class="weui-cell__bd">
      <slot>
        <p>{{ text }}</p>
      </slot>
    </div>
  </label>
</template>

<script>
import mixinUniqid from '@/mixins/uniqid';

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            id: this.uniqid(),
            checked: false,
        };
    },
    watch: {
        value(val) {
            this.checked = val;
        },
    },
    created() {
        this.checked = this.value;
    },
    methods: {
        updateChecked(event) {
            this.checked = event.target.checked;
            this.$emit('input', event.target.checked);
        },
    },
    mixins: [
        mixinUniqid,
    ],
};
</script>



// WEBPACK FOOTER //
// src/components/weui/checkbox/Index.vue